<template>
  <div>
    <Header
      :history="history"
      :data="drawerData"
      :action="action"
      @goBack="goBack"
      @toggleAction="toggleAction"
      @close="close"
    />

    <transition name="fade">
      <div v-if="isSuccess">
        <Preview
          v-if="action === 'preview'"
          :data="drawerData"
          @change="change"
          @toggleAction="toggleAction"
        />

        <Edit
          v-if="action === 'edit'"
          :data="drawerData"
          @toggleAction="toggleAction"
          @close="close"
        />
      </div>
    </transition>

    <div
      v-if="isLoading"
      class="progress__wrapper text-xs-center py-5"
      :style="`height: ${contentHeight}px`"
    >
      <div class="progress">
        <v-progress-circular indeterminate color="primary" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { hasRole } from 'utils/functions'
import { calcContentHeight, catchError } from 'corp-front-vue-commons/src/utils/functions'
import Header from './Header'
import Preview from './Preview'
import Edit from './Edit'

export default {
  name: 'Project',
  props: {
    data: {
      type: Object,
      default: () => {}
    },

    actionType: {
      type: String,
      default: 'preview'
    },

    history: {
      type: Array,
      default: () => []
    },

    drawerType: {
      type: String,
      required: true
    }
  },
  components: {
    Header,
    Preview,
    Edit
  },
  computed: {
    ...mapState({
      costCenterTemporaryDisabled: ({ globalDrawer }) => globalDrawer.costCenterTemporaryDisabled
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      currentStatus: null,
      drawerData: {},
      rides: [],
      contentHeight: 'none',
      action: 'preview'
    }
  },
  methods: {
    ...mapActions({
      setCostCenterTemporaryDisabled: 'globalDrawer/set'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload) {
      this.action = 'preview'
      this.$emit('close', reload)
    },

    change (val) {
      this.$emit('change', val)
    },

    async loadData () {
      if (this.currentStatus === STATUS_IS_LOADING || !this.hasRole('project', 'ROLE_GET_PROJECT_ID')) {
        this.currentStatus = STATUS_SUCCESS
        return
      }

      this.currentStatus = STATUS_IS_LOADING

      try {
        const { data: res } = await this.$apiService.project.getById(this.data.id)
        this.drawerData = res.data

        this.$emit('updateHistory', {
          drawerType: 'project',
          data: this.data
        })

        this.currentStatus = STATUS_SUCCESS
      } catch (error) {
        catchError(error)
        this.currentStatus = STATUS_FAILED
      }
    },

    toggleAction (action) {
      this.action = action
      if (action === 'preview') this.loadData()
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.loadData()
      }
    },

    actionType (val) {
      val && this.toggleAction(val)
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
    this.actionType && this.toggleAction(this.actionType)
    this.loadData()
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.progress__wrapper {
  position: relative;
}

.progress {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%)
}

.content__title {
  color: var(--gray-7);
  font-family: $title-font + 1px;
  font-size: $base-font-size;
  font-weight: 700;
  padding: 22px 24px;
  text-align: center;
}
</style>
